// blog33.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg";
import detailImg from "../Asets/blog3636.png";
import Header from "../components/header";
import Footer from "../components/footer";

const Blog33 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span>
                {" "}
                / Our Blog / Best Christmas Poems for Kids
              </span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Best Christmas Poems for Kids: Short, Funny & Easy Rhymes to Celebrate
          </h2>

          <br />
          <div className="published-badge">
            Published on: 11 December 2025
          </div>
          <br />

          <img
            src={detailImg}
            alt="Best Christmas Poems for Kids"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              Christmas is a magical season filled with lights, joy, family
              togetherness, and festive fun. Children especially love this time
              of year — singing carols, decorating the Christmas tree, and
              listening to cheerful holiday poems.
            </p>
            <p>
              To make celebrations even more joyful, here are the best Christmas
              poems for kids that are short, funny, easy to recite, and perfect
              for school events, performances, or family gatherings.
            </p>

            <hr />

            <h3>🎄 1. Short &amp; Sweet Christmas Poems for Kids</h3>

            <p><strong>Poem: “Little Christmas Star”</strong></p>
            <p>
              Twinkle, twinkle Christmas star,<br />
              How I wonder what you are.<br />
              Shining bright for all to see,<br />
              Guiding Santa magically.
            </p>

            <p><strong>Poem: “My Christmas Wish”</strong></p>
            <p>
              I don’t want toys, I don’t want snow,<br />
              I just want love to softly grow.<br />
              A hug, a smile, a happy cheer —<br />
              That’s all I want this time of year.
            </p>

            <hr />

            <h3>😂 2. Funny Christmas Poems for Kids</h3>

            <p><strong>Poem: “Santa’s Lost Sock”</strong></p>
            <p>
              Santa looked around in shock —<br />
              “Oh no! I lost my Christmas sock!”<br />
              The elves laughed loud, “Don’t you fear,<br />
              We’ll knit a new one every year!”
            </p>

            <p><strong>Poem: “Santa’s Diet Day”</strong></p>
            <p>
              Santa said, “No sweets today!”<br />
              But kids kept giving them anyway.<br />
              He tried to stop… with all his might…<br />
              But ate them all on Christmas night!
            </p>

            <hr />

            <h3>🔔 3. Easy Rhyming Christmas Poems for Little Kids</h3>

            <p><strong>Poem: “Jingle, Jingle Little Bell”</strong></p>
            <p>
              Jingle, jingle little bell,<br />
              Christmas stories love to tell.<br />
              Ring so bright, ring so clear,<br />
              Spread the joy of Christmas cheer.
            </p>

            <p><strong>Poem: “Cookie for Santa”</strong></p>
            <p>
              One cookie for Santa,<br />
              One cookie for me…<br />
              But oops! I ate both —<br />
              How naughty could I be?
            </p>

            <hr />

            <h3>❤️ 4. Meaningful Christmas Poems for Kids</h3>

            <p><strong>Poem: “A Christmas Hug”</strong></p>
            <p>
              A hug can warm the coldest night,<br />
              Can fill your heart with pure delight.<br />
              Give one freely, hold it tight —<br />
              A hug makes Christmas shine so bright.
            </p>

            <p><strong>Poem: “The Gift of Love”</strong></p>
            <p>
              Gifts may sparkle, gifts may shine,<br />
              But love is the greatest gift you’ll find.<br />
              Share some joy, spread some cheer —<br />
              That’s the magic every year.
            </p>

            <hr />

            <h3>🎓 Why Choose Red School House Vadodara?</h3>
            <p>
              As the <strong>Best Play School in Vadodara</strong>, Red School
              House is known for joyful learning, creativity-focused teaching,
              and a safe, loving environment where children grow with confidence.
            </p>

            <p><strong>Reasons to Choose Us:</strong></p>
            <ul>
              <li>Play-based learning approach</li>
              <li>Caring and trained teachers</li>
              <li>Safe &amp; hygienic classrooms</li>
              <li>Confidence-building activities</li>
              <li>Creative learning environment</li>
              <li>Harni Sama Link Road location</li>
              <li>Trusted by Vadodara parents</li>
            </ul>

            <hr />

            <h3>📞 Contact Us – Red School House Vadodara</h3>
            <p>
              <strong>Address:</strong> A-25, Castle White, Opp. Main Harni Water
              Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile:</strong>{" "}
              <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">
                redschoolhousebaroda2025@gmail.com
              </a>
              <br />
              <strong>Website:</strong>{" "}
              <a
                href="https://redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                https://redhouseschoolvadodara.in/
              </a>
              <br />
              <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/redschoolhousebaroda/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.instagram.com/redschoolhousebaroda/
              </a>
            </p>

            <p className="blog-tags">
              #ChristmasPoemsForKids &nbsp;
              #RedSchoolHouseVadodara &nbsp;
              #BestPlaySchoolVadodara &nbsp;
              #KidsLearning &nbsp;
              #FestiveLearning &nbsp;
              #HarniSama
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog33;
